import type {
  ProductReOrderRequestType,
  ProductReOrderResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

type ProductReOrderMutationData = ProductReOrderRequestType & {
  productId: number;
};

export const useProductReOrder = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({ productId, ...data }: ProductReOrderMutationData) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `products/${productId}/re-order`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as ProductReOrderResponseType,
      ),

    onSettled: (_data, _error, variables) => {
      if (variables) {
        queryClient.invalidateQueries({
          queryKey: [
            business?.id,
            ServerStateKeys.Products,
            variables.productId,
          ],
        });
      }
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
